// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1fi3c","ranges":"BmiRanges_ranges__36Q6b"};